import Api, { handleError } from '../Api';
import request from '../request';
import { ModelOptions } from '../../types';

import { url } from './config';
import { Hotel } from './types';
import { HotelQueryType } from './helpers';

class ExtendedApi extends Api<Hotel> {
    async query(query: HotelQueryType, options?: ModelOptions) {
        try {
            const params = { ...query, ...options };
            const res = await request.get<Hotel[]>(`${url}-query`, { params });
            return res.data;
        } catch (err) {
            return handleError(err);
        }
    }

    async queryPaginated(body: { query?: Record<string, any>; page?: number; pageSize?: number; sort?: any[] }) {
        try {
            const res = await request.post(`${url}-query-paginated`, body);
            return res.data;
        } catch (err) {
            return handleError(err);
        }
    }
}
const api = new ExtendedApi(url);

export default api;
